// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"002c719b","317":"49ebc8c5","453":"a8c3d6b7","805":"aa5a4d9b","874":"6a0c5a05"}[chunkId] + ".chunk.js";
};